import { render, staticRenderFns } from "./AddressFormDrawer.vue?vue&type=template&id=f4b8710e&"
import script from "./AddressFormDrawer.vue?vue&type=script&lang=js&"
export * from "./AddressFormDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GoogleAutoComplete: require('/home/jeanmarcphilippe/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/components/GoogleAutoComplete.vue').default})
